export default "__VITE_ASSET__CKrU7OzM__"